import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {SessionActions} from "../../../shared/actions/session.actions";
import {Stock} from "../../../shared/view-model/stock";
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";

@Component({
  selector: 'vb-select-stock-for-storage',
  templateUrl: './select-stock-for-storage.component.html',
  styleUrls: ['./select-stock-for-storage.component.css']
})
export class SelectStockForStorageComponent extends AbstractVisbosControl<Stock, FormControl> implements OnInit {

  @Input()
  itemLabelFunction: (item: Stock) => string = (item: Stock) => {
    return item.depot.label + (item.depot_yard ? ", " + item.depot_yard.label : '') + (item.identities && item.identities[0] ? ' (EAN: ' + item.identities[0].ean + ')' : '');
  };

  @Input()
  stocks: Stock[];

  @Output()
  stockSelect: EventEmitter<Stock> = new EventEmitter();


  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions) {
    super(fb, cd, sessionActions);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  public buildControlContent(values?: Stock, ...params: any[]): FormControl {
    return this.fb.control(null, Validators.required);
  }

  public setDefaultValues(item?: Stock): { [controlKey: string]: any } | any {
    return this.setValue(item, 'cuid');
  }

  onStockSelected(stock: Stock) {
    this.stockSelect.emit(stock);
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/procurement/select-stock-for-storage/select-stock-for-storage.component.ts